import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericService } from './generic.service';
import { CompanyRoleModel } from '../models/company-role.model';

@Injectable({
	providedIn: 'root',
})
export class RolesService extends GenericService<CompanyRoleModel> {
	private http1 = inject(HttpClient);

	constructor() {
		super();
		this.endpoint = 'roles';
		this.ACTIONS = {
			list: 'ROLE_LIST',
			add: 'ROLE_ADD',
			update: 'ROLE_UPDATE',
			delete: 'ROLE_DELETE',
			item: 'ROLE_ITEM',
		};
	}

	getManyCompanyRoles = (companyUuid: any, params: {}) => {
		this.endpoint = `companies/${companyUuid}/roles`;
		return super.list(params);
	};

	postOneCompanyRole = (companyUuid: any, role: any) => {
		this.endpoint = `companies/${companyUuid}/roles`;
		return super.add(role);
	};

	patchOneCompanyRole = (companyUuid: any, roleUuid: any, role: any) => {
		this.endpoint = `companies/${companyUuid}/roles/${roleUuid}`;
		return super.patch(role);
	};

	deleteOneCompanyRole = (companyUuid: any, roleUuid: any) => {
		this.endpoint = `companies/${companyUuid}/roles`;
		return super.delete(roleUuid);
	};
}
